import { render, staticRenderFns } from "./ChevronLeft.vue?vue&type=template&id=1aae5fea&"
import script from "./ChevronLeft.vue?vue&type=script&lang=ts&"
export * from "./ChevronLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports